import Vue from "vue";
import {$api} from "@/services";
import {$banxicoSIE} from "@/services/external"

Vue.mixin({
  computed: {
    $api: () => $api,
    $banxicoSIE: () => $banxicoSIE,
  }
});